import { render, staticRenderFns } from "./quotations-tab.vue?vue&type=template&id=26b30a0a&scoped=true&"
import script from "./quotations-tab.vue?vue&type=script&lang=js&"
export * from "./quotations-tab.vue?vue&type=script&lang=js&"
import style0 from "./quotations-tab.vue?vue&type=style&index=0&id=26b30a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b30a0a",
  null
  
)

export default component.exports